import React, { useState, useEffect } from "react";
import { BiSolidMap } from "react-icons/bi";
import { BiEditAlt } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { Search } from "react-bootstrap-icons";
import axios from "axios";
import { Table, Modal, ModalHeader, ModalBody, NavLink } from "reactstrap";
import ReactPaginate from "react-paginate";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import SearchableDropdown from "../../searchableDropdown";
import ReactSelect from "../../ReactSelect";
import Select from "react-select";
import { CSVLink } from "react-csv";
import { baseUrl } from "../../api/apiConfig";
import { RiDeleteBin5Line } from "react-icons/ri";
import ClosedBookingsEditModal from "../../components/editModals/ClosedBookingsEditModal";
import FareEditModal from "../../FareEditModal";
import WaitingChargeEditModal from "../../WaitingChargeEditModal";
import TimeEditModal from "../../TimeEditModal";
import VegamEditModal from "../../VegamEditModal";
// CSS...
import "../../styles/Tours/bookingModal.css";
import "../../styles/closedBooking/closedBooking.css" //Nothing in this CSS file..

const data = [
  { value: "Divya-9962062282", label: "Divya-9962062282" },
  { value: "Prakash-9789460828", label: "Prakash-9789460828" },
  { value: "Suby-9605432304", label: "Suby-9605432304" },
];
const data1 = [
  { value: "Divya-null-9962062282", label: "Divya-null-9962062282" },
  { value: "Prakash-Test-9789460828", label: "Prakash-Test-9789460828" },
  { value: "Suby-IIT Madras-9605432304", label: "Suby-IIT Madras-9605432304" },
];

const ClosedBookings = () => {
  const [closedBookData, setClosedBookData] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [customerId, setCustomerId] = useState(0);
  const [driverList, setDriverList] = useState("");
  const [driverName, setDriverName] = useState("");

  const [params, setParams] = useState({
    id:localStorage.getItem("closedBooking_Id")?localStorage.getItem("closedBooking_Id"):"",
    customer_id:localStorage.getItem("Closed_booking_cusId")?localStorage.getItem("Closed_booking_cusId"):"",
    driver_name:localStorage.getItem("Closed_booking_driverId")?localStorage.getItem("Closed_booking_driverId"): "",
    pickup_time:localStorage.getItem("Closed_booking_PickupTime")?localStorage.getItem("Closed_booking_PickupTime"):"",
    reached_pickup:localStorage.getItem("Closed_booking_ReachedTime")?localStorage.getItem("Closed_booking_ReachedTime"):"",
    created_at:localStorage.getItem("Closed_booking_CreatedAt")?localStorage.getItem("Closed_booking_CreatedAt"): "",
    status:localStorage.getItem("Closed_booking_Status")?localStorage.getItem("Closed_booking_Status"): "",
    booking_status:localStorage.getItem("Closed_booking_TourStatus")?localStorage.getItem("Closed_booking_TourStatus"): "",
    booking_type:localStorage.getItem("closed_booking_type")?localStorage.getItem("closed_booking_type"): "",
    customer_name: "",
    offset: 0,
    limit: 10,
    from_manager_app: true,

  });
  console.log("closedbookings params",params)
  const [pickupTime, setPickupTime] = useState("");
  const [createdTime, setCreatedTime] = useState("");
  const [reachedPickupTime, setReachedPickupTime] = useState("");
  const [status, setStatus] = useState("");
  const [bookingStatus, setBookingStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [home_delv, setHome_delv] = useState(false);
  const [charge, setCharge] = useState(false);
  const [bookData, setBookData] = useState(false);
  const [booking, setBooking] = useState(false);
  const [addbooking, setAddBooking] = useState(false);
  const [pickup_location, setPickup_location] = useState(false);
  const [date1, setDate1] = useState(null);
  const [date2, setDate2] = useState(null);
  const [date3, setDate3] = useState(null);
  const [date4, setDate4] = useState(null);
  const [date5, setDate5] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const[newFare,setNewFare]=useState(false)
  const [pickup_time, setPickup_time] = useState(null);
  const [goods_time, setGoods_time] = useState(null);
  const [dropoff_time, setDropoff_time] = useState(null);
  const [deliver_time, setDeliver_time] = useState(null);
  const [exp_book_modalstate, setExp_book_modalstate] = useState("");
  const [book_modal_drivState, setBook_modal_drivState] = useState("");
  const [book_modal_cusState, setBook_modal_cusState] = useState("");
  // download btns
  const [customerDetails, setCustomerDetails] = useState([]);
  const [bookingReport, setBookingReport] = useState([]);
  const [value, setValue] = useState(null);
  const [isClearable, setIsClearable] = useState(true);
  const [homeDelBtn, setHomeDelBtn] = useState(false);
  const [dateMessage, setDateMessage] = useState(false);
  const [exporturl, setExportUrl] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);
  const [downloadBtn, setDownloadBtn] = useState(false);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [closedBookingModal, setClosedBookingModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [cusId, setCusId] = useState(null);
  const [pickupAddress, setPickupAddress] = useState([]);
  const [dropoffAddress, setDropoffAddress] = useState([]);
  const [editfare, setEditfare] = useState(false);
  const [waitingCharges, setWaitingCharges] = useState(false);
  const [editTime, setEditTime] = useState(false);
  const [isVegamEdit, setIsVegamEdit] = useState(false);


  const[obj,setObj]=useState({})


  const handleEditFare = () => {
    setEditfare(!editfare);
  };
  const getObj=(obj)=>{
    setObj(obj);
}
  const handle_waitingCharges = () => {
    setWaitingCharges(!waitingCharges);
  };
  const handleChangeEditTime = () => {
    setEditTime(!editTime);
  };
  
  const handleVegam = () => {
    setIsVegamEdit(!isVegamEdit)
  }




  const openClosedBookModal = (elem) => {
    setClosedBookingModal(true);
    setEditData(elem);
  };
  const closeClosedBookModal = () => {
    setClosedBookingModal(false);
    setEditData(null);
  };

  const changehome_delv = () => {
    setHome_delv(!home_delv);
    setDate1(null);
    setDate2(null);
    setHomeDelBtn(false);
    setDateMessage(false);
    setErrorMessage(false);
  };
  const changeCharge = () => {
    setCharge(!charge);
    setDate3(null);
    setDateMessage(false);
  };
  const changeBookData = () => {
    setBookData(!bookData);
    setDate4(null);
    setDate5(null);
    setValue(null);
    setDateMessage(false);
    setErrorMessage(false);
    setDownloadBtn(false);
  };
  const changeBooking = () => {
    setBooking(!booking);
  };

  const changeAddBooking = () => {
    setAddBooking(!addbooking);
  };
  const changePickupLocation = () => {
    setPickup_location(!pickup_location);
  };

  // Pagination ...

  const showDataPerPage = 10;
  const offset = pageNumber * showDataPerPage;
  const pageCount = Math.ceil(totalCount / showDataPerPage);
  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
    setLoading(true);
  };
  // console.log(totalCount);
  console.log(pageNumber);
  console.log(offset);

  // Api Calling
  const url = `${baseUrl}/booking/getBookings`;

  const getClosedBookingsData = async (params) => {
      try {
        setLoading(true)
          const response = await axios.post(url, {
          ...params,
          limit: showDataPerPage,
          offset: offset,
        });
        setClosedBookData(response.data.data.bookings);
        setTotalCount(response.data.data.count);
        let totalBookings=response.data.data.count
        localStorage.setItem("totalBookings",totalBookings)
      } catch (error) {
        console.log(`Error in getClosedBookingsData:`,error)
      }finally{
        setLoading(false)
      }
  };
  //customerList,setCustomerList

  const getAllCustomersList = async () => {
    const request = await axios.post(
      `${baseUrl}/users/getAllCustomers`,
      { limit: 600, offset: 0 }
    );
    const cusList = request.data.data.customers;
    console.log(cusList);
    const customersList = cusList.map((item) => ({
      label: item.name,
      value: item.id,
    }));
    setCustomerList(customersList);
  };
  // console.log(customerList);

  const getAllDriversList = async () => {
    const request = await axios.post(
      `${baseUrl}/driver/getDrivers`,
      { limit: 1000, offset: 0 }
    );
    const driversList = request.data.data.drivers;
    console.log(driversList);
    const driverDetail = driversList.map((item) => ({
      label: item.name,
      value: item.name,
    }));
    setDriverList(driverDetail);
  };

  const handleClosedBookingId = (e) => {
    setParams({
      ...params,
      id: e.target.value,
    });
    localStorage.setItem("closedBooking_Id",e.target.value)
    
  };
  // Filter By Time Selection...
  const handlePickupTime = (date) => {
    let pickupTime = moment(date).format("YYYY-MM-DD");
    setPickupTime(pickupTime);
    console.log(pickupTime);
    setParams({ ...params, pickup_time: pickupTime });
    localStorage.setItem("Closed_booking_PickupTime",pickupTime)
  };

  const handleCreatedTime = (date) => {
    let createdTime = moment(date).format("YYYY-MM-DD");
    setCreatedTime(createdTime);
    setParams({ ...params, created_at: createdTime });
    localStorage.setItem("Closed_booking_CreatedAt",createdTime)
  };

  const handleReachedPickupTime = (date) => {
    let reachedPickupTime = moment(date).format("YYYY-MM-DD");
    setReachedPickupTime(moment(date).format("YYYY-MM-DD"));
    setParams({ ...params, reached_pickup: reachedPickupTime });
    localStorage.setItem("Closed_booking_ReachedTime",reachedPickupTime)
  };

  // Status Function...
  const handleStatus = (e) => {
    setStatus(e.target.value);
    setParams({ ...params, status: e.target.value });
    localStorage.setItem("Closed_booking_Status",e.target.value)
  };
  const handleBookingStatus = (e) => {
    console.log(e.target.value);
    setBookingStatus(e.target.value);
    setParams({ ...params, booking_status: e.target.value });
    localStorage.setItem("Closed_booking_TourStatus",e.target.value)
  };

  const handleCustomerSelect = (selectedOptions) => {
    console.log("selectedOption", selectedOptions);
    setCustomerName(customerName?.label);
    setCustomerId(selectedOptions.value);
    setParams({ ...params, customer_id: selectedOptions.value });
    localStorage.setItem("Closed_booking_cusId",selectedOptions.value)
    localStorage.setItem("Closed_booking_cusObj",JSON.stringify(selectedOptions))
  };
  const handleDriverSelect = (selectedOptions) => {
    console.log("selectedOption", selectedOptions);
    setDriverName(driverName?.label);
    setParams({ ...params, driver_name: selectedOptions.value });
    localStorage.setItem("Closed_booking_driverId",selectedOptions.value)
    localStorage.setItem("Closed_booking_driverObj",JSON.stringify(selectedOptions))
    
  };
  console.log(params);

  const clearAllFilters = () => {
    window.location.reload();
    localStorage.removeItem("closedBooking_Id")
    localStorage.removeItem("Closed_booking_PickupTime")
    localStorage.removeItem("Closed_booking_CreatedAt")
    localStorage.removeItem("Closed_booking_ReachedTime")
    localStorage.removeItem("Closed_booking_Status")
    localStorage.removeItem("Closed_booking_TourStatus")
    localStorage.removeItem("Closed_booking_cusId")
    localStorage.removeItem("Closed_booking_cusObj")
    localStorage.removeItem("Closed_booking_driverId")
    localStorage.removeItem("Closed_booking_driverObj")
    localStorage.removeItem("closed_booking_type")
    
    // created_at: "",
    // customer_id: 0,
    // status: "",
    // id: 0,
    // booking_status: "",
    // offset: 0,
    // limit: 10,
    // reached_pickup: "",
    // driver_name: "",
    // customer_name: "",
    // pickup_time: "",
    // from_manager_app: true
    
    
  };
  // All Download buttons fn...

  // 1.Export Home Delivery CSV Btn
  const getHomeDeliveryData = async () => {
    const payload = {
      start_date: moment(date1).format("YYYY-MM-DD"),
      end_date: moment(date2).format("YYYY-MM-DD"),
    };
    if (
      payload.start_date == "Inavlid date" ||
      payload.end_date == "Invalid date"
    ) {
      setDateMessage(true);
    } else {
      setDateMessage(false);
      try {
        console.log("i am called ");
        const request = await axios.post(
          `${baseUrl}/booking/exportInvoiceHomeDeliveryBookingsCsv`,
          payload
        );
        console.log(request, "request getHomeDeliveryData");
        if (request.data.success) {
          setHomeDelBtn(true);
          setExportUrl(request.data.data);
        } else {
          setErrorMessage(true);
        }
      } catch (error) {}
    }
    // setHomeDelBtn(true)
  };

  //2.Estimate Charge Btn ...

  const getEstimateChargeReport = async () => {
    const payload = {
      calc_date: moment(date3).format("YYYY-MM-DD"),
    };
    if (payload.calc_date == "Invalid date") {
      setDateMessage(true);
    } else {
      setDateMessage(false);
      const request = await axios.post(
        `${baseUrl}/location/revenueCalculation`,
        payload
      );
      if (request.data.success) {
        alert("Done");
      }
    }
  };

  //3.Export Booking Data Button ..
  const getAllCustomers = async () => {
    try {
      const request = await axios.post(
        `${baseUrl}/users/getAllCustomers`,
        { limit: 600, offset: 0 }
      );
      if (request.data.success) {
        const result = request.data.data.customers;
        const data = result.map((elem) => ({
          label: `${elem.name}-${elem.mobile}`,
          value: `${elem.id}`,
        }));
        setCustomerDetails(data);
      } else {
      }
    } catch (error) {
      console.log(error,"getAllCustomers");
    }
  };
  // New Fare changes Button fn,,, 

  const newRevenueCalculation=async()=>{
    console.log(moment(fromDate).format("YYYY-MM-DD"))
    console.log(moment(toDate).format("YYYY-MM-DD"))
    const req_DateObj = {
      from_date:moment(fromDate).format("YYYY-MM-DD"),
      to_date:moment(toDate).format("YYYY-MM-DD")
  }
    try {
      const response=await axios.post(`${baseUrl}/location/revenueCalculationDateRange`,req_DateObj)
      console.log(response,"line 410")
      if(response.data.success){
        setFromDate("")
        setToDate("")
        alert("Done");
      }
      
    } catch (error) {
      console.log(error.message)
      
    }
    
  }

  const handleSelectedOption = (selected) => {
    console.log(selected);
    setValue(selected);
    setCustomerId(selected.value);
  };

  const getExportBookingReport = async () => {
    const payload = {
      start_date: moment(date4).format("YYYY-MM-DD"),
      end_date: moment(date5).format("YYYY-MM-DD"),
      customer_id: customerId,
      limit: 5000,
    };
    if (
      payload.start_date == "Invalid date" ||
      payload.end_date == "Invalid date" ||
      payload.customer_id == null
    ) {
      setDateMessage(true);
      setErrorMessage(false);
    } else {
      setDateMessage(false);
      try {
        const request = await axios.post(
          `${baseUrl}/booking/getBookingsDetails`,
          payload
        );
        console.log(request.data.success);
        if (request.data.success) {
          setDownloadBtn(true);
          const result = request.data.data.bookings;
          console.log(result, "resiulyy");
          setBookingReport(result);
        } else {
          setErrorMessage(true);
        }
      } catch (error) {
        setErrorMessage(true);
        console.log(error);
      }
    }
  };

  // Delete Icon  fun,,,

  const handleDeleteModal = (id) => {
    setDeleteModal(!deleteModal);
    setDeleteId(id);
  };
  const deleteSelectedBooking = async (id) => {
    console.log(id, "delete id");
    try {
      // console.log(`${baseUrl}/booking/deleteTrip/${tripId}`);
      const request = await axios.post(
        `${baseUrl}/booking/deleteBooking/${id}`
      );
      if (request.data.success) {
        getClosedBookingsData(params);
        alert(request.data.message);
        setDeleteModal(false);
      }
    } catch (error) {
      alert("Failed to Delete !");
      console.error(error.message);
    }
  };

  // getPickupAddress of customer

  const getAddressofcustomer = async (cusId) => {
    console.log(cusId, "cusid from function");

    try {
      const resp = await axios.post(`${baseUrl}/users/getAddress`, {
        customer_id: cusId,
      });
      console.log(resp, "ooo");
      if (resp.data.success) {
        // alert("done")
        const pickupAddress = resp.data.data.Pickup_address;
        console.log(pickupAddress.length, "PickupAddress Length");
        setPickupAddress(pickupAddress);
        // console.log(resp.data.data.Dropoff_address);
        const dropoffAddress = resp.data.data.Dropoff_address;
        setDropoffAddress(dropoffAddress);
      }
    } catch (error) {
      setPickupAddress("");
      setDropoffAddress("");
      // alert("Failed ?");
      console.log(error);
    }
  };
  useEffect(() => {
    getAddressofcustomer(cusId);
  }, [cusId]);

  useEffect(() => {
    getClosedBookingsData({...params});
  }, [offset]);

  useEffect(() => {
    getAllCustomersList();
    getAllDriversList();
  }, [])
  // console.log(closedBookData);

// for React Select options style
const customStyle = {
  option: (provided, state) => ({
    ...provided,
    padding:"5px",
    margin:"5px",
    backgroundColor: state.isSelected ? '#30A46C' : 'white',
    color: state.isSelected ? 'white' : 'black',
    ':hover': {
      backgroundColor: 'green',
      color:"white",
      
    },
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
    height:"30px"
  }),
};
  
  

  // Add Booking Modal fn -> onClick={changeBooking}..

  return (
    <div style={{ padding: "10px" }}>
      <section className="searchBar-section">
        <div className="session-Top-Input">
          <Search className="searchIcon" />
          <input
            type="text"
            placeholder="Search owner by name,phone or address"
            style={{ width: "310px" }}
          />
        </div>
        <div>
          <button className="btn-big">
            Add Bookings
          </button>
          <button className="btn-big" onClick={changeCharge}>
            Estimate Charge
          </button>
          <button className="btn-big" onClick={changehome_delv}>
            Export Home Delivery CSV
          </button>
          <button
            className="btn-big"
            onClick={() => {
              changeBookData();
              getAllCustomers();
            }}
          >
            Export Booking Data
          </button>
          <button className="btn-big" onClick={()=>setNewFare(true)}>Fare Changes</button>
        </div>
      </section>
      <section
        style={{ marginTop: "50px", overflow: "scroll" }}
        className="section-2"
      >
        <div className="inpBox-1">
          <input
            type="text"
            style={{ width: "100px",height:"38px"}}
            placeholder="Filter By id..."
            onChange={handleClosedBookingId}
          />
          <div style={{ width: "140px" }}>
            <Select
              options={customerList}
              // value={customerName}
              value={localStorage.getItem("Closed_booking_cusObj")?JSON.parse(localStorage.getItem("Closed_booking_cusObj")):""}
              isSearchable
              placeholder="Cus name"
              onChange={handleCustomerSelect}
              menuPortalTarget={document.body}
              styles={customStyle}
            />
            
          </div>
          <div style={{ width: "140px" }}>
            <Select
              options={driverList}
              value={localStorage.getItem("Closed_booking_driverObj")?JSON.parse(localStorage.getItem("Closed_booking_driverObj")):""}
              // value={driverName}
              onChange={handleDriverSelect}
              isSearchable
              placeholder="Driver name"
              menuPortalTarget={document.body}
              styles={customStyle}
            />
          </div>
        </div>
        <div className="inpBox-1" style={{height:"37px"}}> 
          <DatePicker
            className="datePicker1"
            value={params.pickup_time}
            onChange={(date) => handlePickupTime(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Filter pickup time"
          />
          <DatePicker
            className="datePicker1"
            value={params.created_at}
            dateFormat="yyyy-MM-dd"
            onChange={(date) => handleCreatedTime(date)}
            placeholderText="created At"
          />
          <DatePicker
            className="datePicker1"
            value={params.reached_pickup}
            dateFormat="yyyy-MM-dd"
            onChange={(date) => handleReachedPickupTime(date)}
            placeholderText="Reached Pickup-time"
          />
        </div>
        <div className="inpBox-2">
          <select name="" id=""
            value={params.booking_type}
            onChange={(e)=>{
            const bookingType=e.target.value.trim()
            setParams((params)=>({...params,booking_type:bookingType}))
            localStorage.setItem("closed_booking_type",bookingType)
            }}
          >
            <option value="">Choose Booking</option>
            <option value="GoodMove">GoodMove</option>
            <option value="ONDC">ONDC</option>
          </select>
          <select value={params.status} onChange={handleStatus}>
            <option defaultValue>Choose status</option>
            <option value="Accepted">Accepted</option>
            <option value="Canceled By Manager">Canceled By Manager</option>
            <option value="Confirmed">Confirmed</option>
            <option value="Pending">Pending</option>
          </select>
          <select value={params.booking_status} onChange={handleBookingStatus}>
            <option defaultValue>Choose booking status</option>
            <option value="Accepted">Accepted</option>
            <option value="Canceled By Manager">Canceled By Manager</option>
            <option value="Completed drop">Completed drop</option>
            <option value="Completed pickup">Completed pickup</option>
            <option value="Confirmed">Confirmed</option>
            <option value="Created">Created</option>
            <option value="Fare">Fare</option>
            <option value="Pending">Pending</option>
            <option value="Reached drop">Reached drop</option>
            <option value="Reached pickup">Reached pickup</option>
            <option value="Tour Completed">Tour Completed</option>
            <option value="Tour Created">Tour Created</option>
            <option value="Trip Created">Trip Created</option>
          </select>
          <select>
            <option defaultValue>Choose option</option>
            <option value="">Valid</option>
            <option value="">Invalid</option>
          </select>
        </div>
        <div className="buttons">
          <button
            className="btn-small"
            onClick={() => getClosedBookingsData(params)}
          >
            Filter
          </button>
          <button className="btn-small" onClick={clearAllFilters}>
            Clear
          </button>
        </div>
      </section>

      <section id="all_modals">
        <div>
          {/* 3.Export Home Delivery CSV Modal.. */}
          <Modal isOpen={home_delv} id="export-home-modal-mobile">
            <ModalHeader style={{ border: "none" }} toggle={changehome_delv}>
              <p>Filter Data In CSV</p>
            </ModalHeader>
            <ModalBody className="modal-body">
              <p>Choose Date :</p>
              <div className="dateBox">
                <div>
                  <DatePicker
                    selected={date1}
                    onChange={(date) => setDate1(date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Date From"
                    className="datePicker"
                  ></DatePicker>
                </div>
                <div>
                  <DatePicker
                    selected={date2}
                    onChange={(date) => setDate2(date)}
                    placeholderText="To"
                    dateFormat="yyyy-MM-dd"
                    className="datePicker"
                  ></DatePicker>
                </div>
              </div>
              <div className="modalFilterBtn">
                <button className="btn-small" onClick={getHomeDeliveryData}>
                  Filter
                </button>
                {homeDelBtn && (
                  <a
                    target="_blank"
                    href={exporturl}
                    download={"Booking File.csv"}
                    className="btn-small"
                  >
                    Download Data
                  </a>
                )}
                {dateMessage ? "Please choose Date" : ""}
                {errorMessage ? "No Records found" : ""}
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* 2.Estimate Charge Modal...  */}
        <div id="Estimate charge Modal">
          <Modal isOpen={charge} id="estimate-charge-modal-mobile">
            <ModalHeader toggle={changeCharge} style={{ border: "none" }}>
              <p>Fare Estimate</p>
            </ModalHeader>
            <ModalBody className="modal-body">
              <p>Choose Date</p>
              <DatePicker
                selected={date3}
                onChange={(date) => setDate3(date)}
                // showTimeSelect
                // timeFormat="HH:mm"
                className="datePicker"
                dateFormat="yyyy-MM-dd"
              />
              <div className="modalFilterBtn">
                <button className="btn-small" onClick={getEstimateChargeReport}>
                  Estimate
                </button>
                {dateMessage ? "Please Choose Date " : ""}
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* 4.Export Booking Data Modal.. */}
        <div>
          <Modal isOpen={bookData} id="export-booking-modal-mobile">
            <ModalHeader style={{ border: "none" }} toggle={changeBookData}>
              Filter Booking Data :
            </ModalHeader>
            <ModalBody className="modal-body">
              <p>Customer Name :</p>
              <div>
                <ReactSelect
                  isClearable={isClearable}
                  value={value}
                  options={customerDetails}
                  placeholder={"Choose or Search customer"}
                  handleSelectedOption={handleSelectedOption}
                  isMulti={false}
                />
              </div>
              <p style={{ marginTop: "15px" }}>Period of Time </p>
              <div className="dateBox">
                <DatePicker
                  selected={date4}
                  onChange={(date) => setDate4(date)}
                  className="datePicker"
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select Date From"
                />
                <DatePicker
                  selected={date5}
                  onChange={(date) => setDate5(date)}
                  className="datePicker"
                  dateFormat="yyyy-MM-dd"
                  placeholderText="To"
                />
              </div>
              <div className="modalFilterBtn">
                <button className="btn-small" onClick={getExportBookingReport}>
                  Filter
                </button>
                {downloadBtn && (
                  <CSVLink
                    className="btn-small"
                    filename="Bookings.csv"
                    data={bookingReport}
                    target="_blank"
                  >
                    Download
                  </CSVLink>
                )}
                {dateMessage ? "Please Fill the field" : ""}
                {errorMessage ? "No Records are Found." : ""}
              </div>
            </ModalBody>
          </Modal>
        </div>
        {/* 5.newFare chatngess */}
        <div>
        <Modal isOpen={newFare} id="">
            <ModalHeader style={{ border: "none" }} toggle={()=>setNewFare(false)}>
              <p>Fare Changes:</p>
            </ModalHeader>
            <ModalBody className="modal-body">
              <p>Choose Date :</p>
              <div className="dateBox">
                <div>
                  <DatePicker
                    selected={fromDate}
                    onChange={(date) => setFromDate(date)}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="From Date"
                    className="datePicker"
                  ></DatePicker>
                </div>
                <div>
                  <DatePicker
                    selected={toDate}
                    onChange={(date) => setToDate(date)}
                    placeholderText="To Date"
                    dateFormat="yyyy-MM-dd"
                    className="datePicker"
                  ></DatePicker>
                </div>
              </div>
              <div className="modalFilterBtn">
                <button className="btn-small" onClick={newRevenueCalculation}>
                  Estimate
                </button>
                
              </div>
            </ModalBody>
        </Modal>

        </div>

        <section>
          <div>
            <Modal isOpen={pickup_location} className="pickupLocation_Modal">
              <ModalHeader
                toggle={changePickupLocation}
                style={{ border: "none" }}
              >
                <p style={{ position: "relative", top: "10px" }}>
                  Choose Pickup Location
                </p>
              </ModalHeader>
              <ModalBody>
                <NavLink>Address List :</NavLink>
                <div>
                  <Search
                    size={14}
                    style={{ position: "relative", left: "20px" }}
                  />
                  <input type="text" placeholder="Search Address" />
                </div>
              </ModalBody>
            </Modal>
          </div>
        </section>

        <section>
          <Modal isOpen={addbooking} id="drop-offLocation_Modal">
            <ModalHeader toggle={changeAddBooking} style={{ border: "none" }}>
              <p style={{ position: "relative", top: "10px" }}>
                Choose Drop-off Location
              </p>
            </ModalHeader>
            <ModalBody>
              <NavLink>Address List :</NavLink>
              <div>
                <Search
                  size={14}
                  style={{ position: "relative", left: "20px" }}
                />
                <input type="text" placeholder="Search Address" />
              </div>
            </ModalBody>
          </Modal>
        </section>

        <section id="DeleteModal">
          {/* Delete Modal */}
          <Modal isOpen={deleteModal} size="sm" style={{ marginTop: "5%" }} className="delete-modal-mobile tab">
            <ModalHeader
              toggle={handleDeleteModal}
              style={{ border: "none" }}
            ></ModalHeader>
            <ModalBody>
              <div id="deleteModalBody">
                <p>Are you sure you want to delete?</p>
                <div className="confirm-cancel-button">
                  <button onClick={() => deleteSelectedBooking(deleteId)}>
                    Confirm
                  </button>
                  <button onClick={() => handleDeleteModal()}>Cancel</button>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </section>

        <div id="AddBooking-modal">
          <Modal isOpen={booking} size="lg">
            <ModalHeader toggle={changeBooking} style={{ border: "none" }}>
              <p>Add Bookings :</p>
            </ModalHeader>
            <ModalBody>
              <div style={{ padding: "2px", margin: "2px" }}>
                <div className="addbookform-Div">
                  <form className="addbookforms">
                    <label htmlFor="chooseCus">Choose Customer:</label>
                    <div>
                      <SearchableDropdown
                        state={book_modal_cusState}
                        setState={setBook_modal_cusState}
                        data={data1}
                      />
                    </div>
                    <label htmlFor="commodity">Commodity Weight :</label>
                    <input
                      type="text"
                      placeholder="Enter Commodity Weight"
                      id="commodity"
                    />
                    <label htmlFor="pickup">Pickup Location :</label>
                    <div className="pickup-Div">
                      <div>
                        <input
                          type="text"
                          placeholder="Choose Pickup Location"
                          id="pickup"
                        />
                      </div>
                      <div>
                        <BiSolidMap
                          onClick={changePickupLocation}
                          size={50}
                          color="green"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                    <label htmlFor="location">Dropoff Loaction :</label>
                    <div className="pickup-Div">
                      <div>
                        <input
                          type="text"
                          placeholder="Choose Dropoff Location"
                          id="location"
                        />
                      </div>
                      <div>
                        <BiSolidMap
                          onClick={changeAddBooking}
                          size={50}
                          color="green"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>

                    <label htmlFor="choosedriver">Choose Driver :</label>
                    <SearchableDropdown
                      state={book_modal_drivState}
                      setState={setBook_modal_drivState}
                      data={data}
                    />
                    <label htmlFor="booking-type">Choose Booking Type :</label>
                    <select
                      name=""
                      id=""
                      style={{
                        width: "550px",
                        padding: "3px",
                        marginBottom: "15px",
                      }}
                    >
                      <option value="single" key="">
                        single
                      </option>
                      <option value="combine" key="">
                        combine
                      </option>
                    </select>
                    <label htmlFor="pickup-time">Reached Pickup Time :</label>
                    <DatePicker
                      style={{ width: "550px" }}
                      placeholderText="Choose Time"
                      selected={pickup_time}
                      onChange={(date) => setPickup_time(date)}
                      dateFormat="dd-MM-yyyy"
                      timeFormat="HH:mm"
                      showTimeSelect
                      showTimeInput
                    />

                    <label htmlFor="goods-pickup-time">
                      Pickedup Goods Time :
                    </label>
                    <DatePicker
                      style={{ width: "550px" }}
                      placeholderText="Choose Time"
                      selected={goods_time}
                      onChange={(date) => setGoods_time(date)}
                      dateFormat="dd-MM-yyyy"
                      timeFormat="HH:mm"
                      showTimeSelect
                      showTimeInput
                    />
                    <label htmlFor="drop-time">Reached Dropoff Time :</label>
                    <DatePicker
                      style={{ width: "550px" }}
                      placeholderText="Choose Time"
                      selected={dropoff_time}
                      onChange={(date) => setDropoff_time(date)}
                      dateFormat="dd-MM-yyyy"
                      timeFormat="HH:mm"
                      showTimeSelect
                      showTimeInput
                    />
                    <label htmlFor="deliver-time">Delivered Time :</label>
                    <DatePicker
                      style={{ width: "550px" }}
                      placeholderText="Choose Time"
                      selected={deliver_time}
                      onChange={(date) => setDeliver_time(date)}
                      dateFormat="dd-MM-yyyy"
                      timeFormat="HH:mm"
                      showTimeSelect
                      showTimeInput
                    />
                    <p style={{ padding: "2px", marginBottom: "30px" }}>
                      <span style={{ position: "absolute", right: "460px" }}>
                        <input type="checkbox" id="loading" />
                      </span>
                      <span style={{ position: "absolute", left: "85px" }}>
                        Loading/Unloading charges applicable ?
                      </span>
                    </p>
                    <label htmlFor="info">Additional Information :</label>
                    <input
                      type="text"
                      placeholder="Enter Additional Information "
                      id="info"
                    />
                    <div className="addbook-Btn">
                      <button className="btn-small">ADD</button>
                    </div>
                  </form>
                </div>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </section>

      <section id="closedBookingEdit"></section>
      <ClosedBookingsEditModal
        isOpen={closedBookingModal}
        toggle={closeClosedBookModal}
        editData={editData}
        getClosedBookingsData={getClosedBookingsData}
        pickupAddress={pickupAddress}
        dropoffAddress={dropoffAddress}
      />

        {/* Fare & Waiting charges & Time edit Modal */}
      <TimeEditModal editTime={editTime} handleChangeEditTime={handleChangeEditTime}  item={obj}
        initialFunction={getClosedBookingsData}
        params={params}
        />
      <FareEditModal editfare={editfare} handleEditFare={handleEditFare} item={obj} 
        initialFunction={getClosedBookingsData}
        params={params}
        />

      <WaitingChargeEditModal waitingCharges={waitingCharges} 
        initialFunction={getClosedBookingsData}
        params={params}
        handle_waitingCharges={handle_waitingCharges} item={obj}/>

      <VegamEditModal isOpen={isVegamEdit} 
        initialFunction={getClosedBookingsData}
        params={params}
        handleVegam={handleVegam} item={obj}/>

      {/* {loading ? (
        <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
        <p style={{ fontSize: "16px" }}>Loading....</p>
      </div>
      ) : ("")} */}
        <section>

          <Table responsive style={{ marginTop: "0px" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid black", fontSize: "12px" }}>
                <th>EDIT</th>
                <th>DELETE</th>
                <th>ID</th>
                <th>TOUR ID</th>
                <th>TYPE</th>
                <th>CUSTOMER NAME</th>
                <th>PICKUP LOCATION</th>
                <th>CREATED AT</th>
                <th>DROP OFF LOCATION</th>
                <th>STATUS</th>
                <th>DRIVER NAME</th>
                <th>TOUR STATUS</th>
                <th>REACHED PICKUP TIME</th>
                <th>PICKED UP GOODS TIME</th>
                <th>REACHED DROPOFF TIME</th>
                <th>GOODS DELIVERED TIME</th>
                <th>EDIT TIME</th>
                <th>PAYMENT TYPE</th>
                <th>PAYMENT STATUS</th>
                <th>ESTIMATE FARE(Rs)</th>
                <th>AMOUNT COLLECTED(Rs)</th>
                <th>WEIGHT</th>
                <th>WAITING CHARGES</th>
                <th>DATE ENTRIES</th>
                <th>VIVEGAM</th>
                <th>ADDITIONAL INFO</th>
                <th>INVOICE</th>
                <th>LOADING</th>
                <th>UNLOADING</th>
                <th>BOTH LOADING & UNLOADING</th>
              </tr>
            </thead>
            <tbody>
              {
                loading ? (
                <tr>
                  <td colSpan={15}>
                    <div className="loading-spinner-container">
                    <div className="loading-spinner"></div>
                    <p style={{ fontSize: "16px" }}>Loading....</p>
                  </div>
                  </td>
                </tr>
              ) :
              closedBookData.length > 0 ?
                closedBookData.map((elem, index) => {
                  return (
                    <tr
                      key={index}
                      style={{ borderBottom: "1px solid lightgrey" }}
                    >
                      <td style={{ fontSize: "18px", cursor: "pointer" }}>
                        <BiEditAlt
                          className="edit-icon"
                          onClick={() => {
                            openClosedBookModal(elem);
                            setCusId(elem.customer_id);
                            // getAddressofcustomer(elem.customer_id);
                          }}
                        />
                      </td>
                      <td style={{ fontSize: "18px", cursor: "pointer" }}>
                        <RiDeleteBin5Line
                          className="deleteIcon"
                          onClick={() => handleDeleteModal(elem.id)}
                        />
                        {/* "customer_id":256 / 282 - users/getAddress-users/getAllCustomers */}
                      </td>
                      <td>{elem.id}</td>
                      <td>{elem.tour_id}</td>
                      <td>{elem.booking_type}</td>
                      <td>{elem.customer_name}</td>
                      <td>{elem.pickup_location}</td>
                      <td>{moment(elem.created_at).format("YYYY-MM-DD HH:mm:ss")}</td>
                      <td>{elem.dropoff_location}</td>
                      <td>{elem.status}</td>
                      <td>{elem.driver_name}</td>
                      <td>{elem.booking_status}</td>
                      <td>{elem.reached_pickup}</td>
                      <td>{elem.completed_pickup}</td>
                      <td>{elem.reached_drop}</td>
                      <td>{elem.completed_drop}</td>
                      <td style={{ fontSize: "18px", cursor: "pointer" }}>
                        <BiEditAlt 
                        onClick={()=>{
                          handleChangeEditTime()
                          getObj(elem)
                         }}/>
                      </td>
                      <td>{(elem.is_regular === true && elem.payment_status =="Pending")? "TBE": elem.payment_type}-{
                       elem.payment_made_by === "other_party_pay" ?
                       (elem.trip_type === "oneway" && elem.booking_for === "pickup") ? (elem.payment_status.toLowerCase() != 'completed' ? "Receiver will pay" : "Receiver paid") :
                         (elem.trip_type === "oneway" && elem.booking_for === "drop") ? (elem.payment_status.toLowerCase() != 'completed' ? "Sender will pay" : "Sender paid") :
                           (elem.trip_type === "round" && elem.booking_for === "pickup") ? (elem.payment_status.toLowerCase() != 'completed' ? "Receiver will pay" : "Receiver paid") :
                             (elem.trip_type === "round" && elem.booking_for === "drop") ? (elem.payment_status.toLowerCase() != 'completed' ? "Sender will pay" : "Sender paid") : "" :
                       elem.payment_made_by === "pay_at_pickup" ? (elem.payment_status.toLowerCase() != 'completed' ? "Sender will pay" : "Sender paid") :
                         elem.payment_made_by === "pay_at_drop" ? (elem.payment_status.toLowerCase() != 'completed' ? "Receiver will pay" : "Receiver paid") :
                           elem.payment_made_by === "ill_pay" ? (elem.payment_status.toLowerCase() != "completed" ? "Customer choose to pay" : "Customer paid") : elem.payment_made_by
                    }</td>
                      <td>{elem.payment_status}</td>
                        <td>
                        {/* {elem.multi_booking_id ? elem.fare  : elem.total_booking_fare } */}
                        {
                          elem.booking_type === "ONDC" && elem.multi_booking_id ? elem.estimated_fare :
                          (elem.booking_type === null && elem.multi_booking_id ? elem.fare : elem.total_booking_fare)
                        }
                          <pre>
                            <BiEditAlt
                              onClick={()=>{
                                handleEditFare()
                                getObj(elem)
                              }}
                                style={{ fontSize: "18px", cursor: "pointer" }}
                              />
                              {/* {elem.multi_booking_id ? elem.amount_collected : elem.fare}{" "} */}
                            </pre>
                        </td>
                        <td>
                        {/* {elem.multi_booking_id ? elem.fare  : elem.total_booking_fare} */}
                        {
                          elem.booking_type === "ONDC" && elem.multi_booking_id ? elem.requestInfo.collection_amount :
                          (elem.booking_type === null && elem.multi_booking_id ? elem.fare : elem.total_booking_fare)
                        }
                          <pre>
                          <BiEditAlt
                            onClick={()=>{
                              handleEditFare()
                              getObj(elem)
                            }}
                              style={{ fontSize: "18px", cursor: "pointer" }}
                            />
                            {/* {elem.multi_booking_id ? elem.amount_collected : elem.fare}{" "} */}
                          </pre>
                        </td>
                      <td>{elem.commodity_weight} {elem.weight_unit == 12 ? "Kg":"Cu.ft"}</td>
                      <td>
                        <BiEditAlt
                        onClick={()=>{
                          handle_waitingCharges()
                          getObj(elem)
                        }}
                          style={{ fontSize: "18px", cursor: "pointer" }}
                        />{elem.waiting_charge}{" "}
                      </td>
                      <td>{elem.is_manager_entered ? "INVALID":"VALID"}</td>
                      <td>
                        {elem.is_vivegam ? "Yes" : "No"}
                      </td>
                      
                      <td>{elem.instruction}</td>
                      <td>{elem.invoice_number == null ? "":elem.invoice_number}</td>
                      <td>{elem.loading_charge_applicable == true ? "Yes":"No"}</td>
                      <td>{elem.unloading_charge_applicable == true ? "Yes":"No"}</td>
                      <td>{elem.both_loading_unloading_charge_applicable == true ? "Yes":"No"}</td>
                    </tr>
                  );
                }) :
                <tr>
                  <td colSpan={10}>
                    <p style={{textAlign:"center",color:"green"}}>No Records are Found....</p>
                  </td>
                </tr>
              }
            </tbody>
            
          </Table>
            
        </section>
       {
        Boolean(closedBookData.length) && <section style={{padding:"10px"}}>
        <div className="paginationContainer" style={{ marginBottom: "20px", position: "relative",left:"100px" }}>
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            pageCount={pageCount}
            onPageChange={handlePageChange}
            containerClassName={"paginationBtns"}
            previousLinkClassName={"previousBtn"}
            nextLinkClassName={"nextBtn"}
            disabledClassName={"paginationDisabled"}
            pageRangeDisplayed={5}
            activeClassName={"paginationActive"}
          />
        </div>
        <p style={{ position: "absolute", left: "550px" ,bottom:"20px"}}>
          {pageNumber + 1} of {pageCount} pages
        </p>
      </section>
       }
    </div>
  );
};

export default ClosedBookings;





